import { ClaimDocumentsGetAdapter } from '../../../adapter';

export default async function ClaimDocumentsGetUseCase(event) {
    const { id } = event;
    const url = window.location.href;
    const isLocalhost = url.includes('localhost') || url.includes('hcc.dev.bpimsapps.com');
    const isUAT = url.includes('hcc.uat.bpimsapps.com');
    const isProd = url.includes('homeprotectionclaims.bpims.com');
    const [, stage, , flag] = url.split('.');

    // prepare data
    const endpoint = isLocalhost
        ? 'https://partners-api.dev.bpimsapps.com/claim/get-documents'
        : isUAT
        ? 'https://partners-api.uat.bpimsapps.com/claim/get-documents'
        : isProd
        ? `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/get-documents`
        : `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/get-documents`;

    // const requestUrl = 'https://partners-api.dev.bpimsapps.com/claim/get-documents';

    const payload = {
        claimId: id
    };

    // handle request
    const result = await ClaimDocumentsGetAdapter(endpoint, JSON.stringify(payload));

    return result;
}
